import { ClipLoader } from "react-spinners";
import styled from "styled-components";
const Button = styled.button`
  display: flex;
  gap: 1rem;
  transition: opacity 0.3s ease-in-out;
  align-items: center;
`;

type LoadingButtonProps = {
  isLoading: boolean;
  children: React.ReactNode;
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
const LoadingButton = ({
  isLoading,
  children,
  ...otherProps
}: LoadingButtonProps) => {
  return (
    <Button
      {...otherProps}
      style={{
        ...otherProps?.style,
        opacity: isLoading ? 0.5 : 1,
        cursor: isLoading ? "not-allowed" : "pointer",
      }}
      disabled={isLoading || otherProps.disabled}
    >
      <ClipLoader color="#fff" size={28} loading={isLoading} />
      {children}
    </Button>
  );
};
export default LoadingButton;
